import { Component, Input } from '@angular/core';
import { EMPTY, tap } from 'rxjs';
import { ModalController } from '@ionic/angular';
import { FormBuilder, Validators } from '@angular/forms';
import { AppValidators } from '@front-end/core/utils';
import { LoadingService, ToastService } from '@libs/ui/uikit';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { PinEditService } from './pin-edit.service';

@UntilDestroy()
@Component({
  selector: 'front-end-card-pin-edit-modal',
  templateUrl: './card-pin-edit-modal.component.html',
  styleUrls: ['./card-pin-edit-modal.component.scss'],
  providers: [PinEditService],
})
export class CardPinEditModalComponent {
  @Input() isActivation = false;

  form = this.fb.group(
    {
      newPin: ['', [Validators.required, Validators.pattern('[0-9]{4}')]],
      confirmNewPin: ['', [Validators.required]],
    },
    { validators: AppValidators.matchPassword('newPin', 'confirmNewPin') }
  );

  constructor(
    private readonly pinService: PinEditService,
    private readonly toastService: ToastService,
    private readonly fb: FormBuilder,
    private readonly loadingService: LoadingService,
    private readonly modalController: ModalController
  ) {}

  close(): void {
    this.modalController.dismiss();
  }

  updatePin(): void {
    if (!this.form.valid) return;

    const pin = this.form.controls.newPin.value ?? '';
    this.pinService
      .updatePin(pin)
      .pipe(
        tap(() => {
          this.toastService.success(
            this.isActivation
              ? 'pages.card-mgmt.edit-pin.activateSuccess'
              : 'pages.card-mgmt.edit-pin.success'
          );
          this.form.reset();
          this.modalController.dismiss();
          return EMPTY;
        }),
        this.loadingService.withLoading(),
        this.toastService.catchAndThrowErrorWithToast(),
        untilDestroyed(this)
      )
      .subscribe();
  }
}
